const periods = [];

const attendances = [];

const deepClone = (value) => JSON.parse(JSON.stringify(value));

export function createParentEducationMockDB() {
  return {
    periods: deepClone(periods),
    attendances: deepClone(attendances),
  };
}
